import { Component } from "vue";
import { PlotHelpContentType } from "../models/PlotHelpContentType";
import { HelpContentFactory } from "@/shared/help/services/HelpContentFactory";


export class PlotHelpContentFactory extends HelpContentFactory<PlotHelpContentType> {

    public cdnContentPath: string = "plots";

    public async tryGetStaticHelpContentByType(type: PlotHelpContentType | string): Promise<Component | null> {
        switch (type) {
            default:
                return null;
        }
    }

}